import { useAtomValue } from "jotai";
import { localeAtom } from "../../stores/locale";
import { useT } from "../../lib/i18n";

// "We don't evaluate. We observe." — the L0 principle, kept visible wherever
// the user talks back to us. Ace loses the moment it reads as an evaluation
// tool; this line reframes the whole surface as observation.
export default function ObserveTagline({ className = "" }: { className?: string }) {
  const locale = useAtomValue(localeAtom);
  const t = useT(locale);
  return (
    <p
      className={`text-[10px] uppercase ${className}`}
      style={{
        fontFamily: "var(--mono)",
        letterSpacing: "0.12em",
        color: "var(--text-dim)",
      }}
    >
      {t("feedback.tagline")}
    </p>
  );
}
